export const Star: React.FC<{
    fillPercentage: number
    width: number
    fillColor: string
}> = ({ fillPercentage, width, fillColor }) => {
    const gradIdName = `grad${fillPercentage}${fillColor}${'transparent'}`
    return (
        <svg height={width} width={width} viewBox="0 0 24 24">
            <defs>
                <linearGradient id={gradIdName}>
                    <stop offset="0%" stopColor={fillColor} />
                    <stop offset={`${fillPercentage}%`} stopColor={fillColor} />
                    <stop
                        offset={`${fillPercentage}%`}
                        stopColor={'transparent'}
                    />
                    <stop offset="100%" stopColor={'transparent'} />
                </linearGradient>
            </defs>
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                fill={`url(#${gradIdName})`}
                stroke={fillColor}
                strokeWidth="1.5"
                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>
    )
}
